import { Cross1Icon, InfoCircledIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import { RotateCw } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const ToolbarContainer = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: ${({ $compact }) => ($compact ? '0.75rem' : '1.5rem')};
  top: ${({ $compact }) => ($compact ? '0.75rem' : '1.5rem')};
  z-index: 10;
  justify-items: center;

  button {
    all: unset;
  }
`

interface PhotoViewerToolbarProps {
  onRotateClockwise?: () => void
  onClose?: () => void
  /** Compact mode for smaller containers like docked panel */
  compact?: boolean
}

export const PhotoViewerToolbar: React.FC<PhotoViewerToolbarProps> = ({
  onRotateClockwise,
  onClose,
  compact = false,
}) => {
  return (
    <ToolbarContainer $compact={compact}>
      <TooltipWrapper
        side={'bottom'}
        offset={5}
        label={'Scroll to zoom, and click and drag to pan'}>
        <ViewToggle onClick={() => {}}>
          <InfoCircledIcon />
        </ViewToggle>
      </TooltipWrapper>
      {onRotateClockwise && (
        <TooltipWrapper
          side={'bottom'}
          offset={5}
          label={'Rotate image clockwise'}>
          <ViewToggle onClick={onRotateClockwise}>
            <RotateCw size={15} />
          </ViewToggle>
        </TooltipWrapper>
      )}
      {onClose && (
        <TooltipWrapper side={'bottom'} offset={5} label={'Close'}>
          <ViewToggle onClick={onClose}>
            <Cross1Icon />
          </ViewToggle>
        </TooltipWrapper>
      )}
    </ToolbarContainer>
  )
}
